import Cookies from 'js-cookie'

const TokenKey = 'lvtu_live_apitoken'
const TokenExpiresAtKey = 'lvtu_live_token_expires_at'

export function getToken() {
  return localStorage.getItem(TokenKey) || Cookies.get(TokenKey)
}

export function setToken(token) {
  if (token) {
    localStorage.setItem(TokenKey, token)
  }
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  localStorage.removeItem(TokenKey)
  localStorage.removeItem(TokenExpiresAtKey)
  return Cookies.remove(TokenKey)
}

export function getTokenExpiresAt() {
  return localStorage.getItem(TokenExpiresAtKey) || ''
}

export function setTokenExpiresAt(expiresAt) {
  if (expiresAt) {
    localStorage.setItem(TokenExpiresAtKey, expiresAt)
  } else {
    localStorage.removeItem(TokenExpiresAtKey)
  }
}

export function saveAuthToken({ token, token_expires_at } = {}) {
  if (token) setToken(token)
  if (token_expires_at) setTokenExpiresAt(token_expires_at)
}
